import React, { useState, useEffect } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  FormGroup,
  Card,
  CardBody,
  Spinner,
  Button,
} from "reactstrap";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";

import {
  getProfile,
  createProfile,
  editProfile,
  resetProfile,
  resetProfiles,
  resetError,
} from "../../store/actions";

const NewProfile = ({ t }) => {
  let { idCompany, idProfile } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    dataProfileGetSet,
    dataProfileEditCreate,
    loadingProfile,
    loadingProfileEditCreate,
    successProfile,
    errorProfile,
  } = useSelector((state) => state.Profile);

  const [profileValues, setProfileValues] = useState({
    name: "",
    description: "",
    role: "",
    department_id: "",
  });

  const [newFields, setNewFields] = useState({});
  const [idDepartment, setIdDepartment] = useState();
  const [enableSubmit, setEnableSubmit] = useState(false);

  const [textAreaBadge, setTextAreaBadge] = useState(false);
  const [textCount, setTextCount] = useState(false);

  const textAreaChange = (e) => {
    var data = e.target.value;
    var count = data.length;

    if (count > 0) {
      setTextAreaBadge(true);
    } else {
      setTextAreaBadge(false);
    }
    setTextCount(data.length);

    if (data === profileValues.description) {
      delete newFields.description;
      checkSubmit();
    } else {
      setNewFields((previous) => ({
        ...previous,
        description: data,
      }));
    }
  };

  const optionsRole = () => {
    let options = [];

    if (loadingProfile) {
      options.push({
        value: "empty",
        label: `${t("Loading")} ...`,
        isDisabled: true,
      });
    } else {
      if (
        dataProfileGetSet &&
        dataProfileGetSet.data &&
        dataProfileGetSet.data.formValues &&
        dataProfileGetSet.data.formValues.roles &&
        dataProfileGetSet.data.formValues.roles.length > 0
      ) {
        options.push({
          value: "",
          label: t("Select"),
          isDisabled: true,
        });
        dataProfileGetSet.data.formValues.roles.map((role, key) =>
          options.push({
            key: key,
            value: role.id,
            label: role.name,
          })
        );
      } else {
        options.push({
          value: "empty",
          label: t("No matching records found"),
          isDisabled: true,
        });
      }
    }

    return options;
  };

  const optionsDepartment = () => {
    let options = [];

    if (loadingProfile) {
      options.push({
        value: "empty",
        label: `${t("Loading")} ...`,
        isDisabled: true,
      });
    } else {
      if (
        dataProfileGetSet &&
        dataProfileGetSet.data &&
        dataProfileGetSet.data.formValues &&
        dataProfileGetSet.data.formValues.departments &&
        dataProfileGetSet.data.formValues.departments.length > 0
      ) {
        options.push({
          value: "",
          label: t("Select"),
          isDisabled: true,
        });
        dataProfileGetSet.data.formValues.departments.map((department, key) =>
          options.push({
            key: key,
            value: department.id,
            label: department.name,
          })
        );
      } else {
        options.push({
          value: "empty",
          label: t("No matching records found"),
          isDisabled: true,
        });
      }
    }
    return options;
  };

  const handleCreateEditProfile = () => {
    if (idProfile) {
      if (idCompany) {
        dispatch(editProfile(idProfile, newFields, idCompany, idDepartment));
      } else {
        dispatch(editProfile(idProfile, newFields));
      }
    } else {
      if (idCompany) {
        dispatch(createProfile(newFields, idCompany, idDepartment));
      } else {
        dispatch(createProfile(newFields));
      }
    }
  };

  const showToast = (type, message) => {
    toastr[type](message);
  };
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () =>
      successProfile &&
      dispatch(resetProfile()) &&
      dispatch(resetProfiles()) &&
      history.push("/profiles"),
  };

  const checkSubmit = () => {
    if (Object.keys(newFields).length !== 0) setEnableSubmit(true);
    else setEnableSubmit(false);
  };

  useEffect(() => {
    checkSubmit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newFields]);

  useEffect(() => {
    dispatch(resetProfile());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (idCompany) {
      dispatch(getProfile(idProfile, idCompany, true));
    } else {
      dispatch(getProfile(idProfile, null, true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idProfile, dispatch]);

  useEffect(() => {
    if (
      idProfile &&
      dataProfileGetSet &&
      dataProfileGetSet.data &&
      dataProfileGetSet.data.profile
    ) {
      setProfileValues((previous) => ({
        ...previous,
        name: dataProfileGetSet.data.profile.name,
        description: dataProfileGetSet.data.profile.description,
        role: dataProfileGetSet.data.profile.role_id,
        department: dataProfileGetSet.data.profile.department_id,
      }));
      setIdDepartment(dataProfileGetSet.data.profile.department_id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataProfileGetSet]);

  useEffect(() => {
    if (dataProfileEditCreate && dataProfileEditCreate.message) {
      showToast("success", t(dataProfileEditCreate.message));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successProfile]);

  useEffect(() => {
    if (errorProfile && typeof errorProfile === "object") {
      errorProfile.map((error) => showToast("error", t(error.value)));
      dispatch(resetError());
    } else {
      if (errorProfile) {
        showToast("error", t(errorProfile));
        dispatch(resetError());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorProfile]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            mainPath="/profiles"
            path={
              idCompany
                ? idProfile
                  ? "/company/" + idCompany + "/profile/" + idProfile
                  : "/company/" + idCompany + "/profile"
                : idProfile
                ? "/profile/" + idProfile
                : "/profile"
            }
            title={t("Profiles")}
            breadcrumbItem={
              !idProfile ? t("Create profile") : t("Edit Profile")
            }
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <AvForm onValidSubmit={handleCreateEditProfile}>
                    <Row>
                      <Col sm="12" md="6">
                        <FormGroup>
                          <AvField
                            label={t("Name") + " *"}
                            id="name"
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder={t("Profile name")}
                            onChange={(e) => {
                              if (e.target.value === profileValues.name) {
                                delete newFields.name;
                                checkSubmit();
                              } else {
                                setNewFields((previous) => ({
                                  ...previous,
                                  name: e.target.value,
                                }));
                              }
                            }}
                            value={profileValues.name}
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t("Required Field"),
                              },
                              maxLength: {
                                value: 45,
                                errorMessage: t("Invalid field"),
                              },
                            }}
                          />
                        </FormGroup>
                        <FormGroup>
                          <AvField
                            id="profileDescription"
                            name="profileDescription"
                            type="textarea"
                            label={t("Description") + " *"}
                            placeholder={t("Description")}
                            className="form-control"
                            rows="3"
                            value={profileValues.description}
                            onChange={textAreaChange}
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t("Required Field"),
                              },
                              maxLength: {
                                value: 255,
                              },
                              minLength: {
                                value: 10,
                                errorMessage: t(
                                  '"description" length must be at least 10 characters long'
                                ),
                              },
                            }}
                          />
                          {textAreaBadge ? (
                            <span className="badgecount badge badge-success">
                              {" "}
                              {textCount} / 255{" "}
                            </span>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col sm="12" md="6">
                        <FormGroup className="select2-container">
                          <AvField
                            name="role"
                            className="form-control"
                            type="select"
                            label={t("Permission type") + " *"}
                            onChange={(e) => {
                              if (e.target.value === profileValues.role) {
                                delete newFields.role_id;
                                checkSubmit();
                              } else {
                                setNewFields((previous) => ({
                                  ...previous,
                                  role_id: e.target.value,
                                }));
                              }
                            }}
                            value={profileValues.role}
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t("Required Field"),
                              },
                            }}
                          >
                            {optionsRole().map((role, key) => (
                              <option
                                key={key}
                                value={role.value}
                                disabled={role.isDisabled}
                              >
                                {role.label}
                              </option>
                            ))}
                          </AvField>
                        </FormGroup>
                        {idCompany && (
                          <FormGroup className="select2-container">
                            <AvField
                              name="department"
                              className="form-control"
                              type="select"
                              label={t("Department") + " *"}
                              options={optionsDepartment()}
                              onChange={(e) => {
                                if (
                                  e.target.value === profileValues.department
                                ) {
                                  delete newFields.department_id;
                                  checkSubmit();
                                } else {
                                  setNewFields((previous) => ({
                                    ...previous,
                                    department_id: e.target.value,
                                  }));
                                  setIdDepartment(e.target.value);
                                }
                              }}
                              value={profileValues.department}
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: t("Required Field"),
                                },
                              }}
                              disabled={idProfile ? true : false}
                            >
                              {optionsDepartment().map((department, key) => (
                                <option
                                  key={key}
                                  value={department.value}
                                  disabled={department.isDisabled}
                                >
                                  {department.label}
                                </option>
                              ))}
                            </AvField>
                          </FormGroup>
                        )}
                      </Col>
                    </Row>

                    <Button
                      type="submit"
                      color="primary"
                      className="mr-1 waves-effect waves-light"
                      style={{
                        minWidth: "100px",
                        cursor: enableSubmit ? "pointer" : "no-drop",
                      }}
                      disabled={!enableSubmit}
                    >
                      {loadingProfileEditCreate ? (
                        <Spinner
                          size="sm"
                          animation="border"
                          style={{
                            height: "19px",
                            width: "19px",
                          }}
                        />
                      ) : (
                        t("Confirm")
                      )}
                    </Button>
                    <Link to="/profiles">
                      {" "}
                      <Button
                        type="button"
                        color="secondary"
                        className="waves-effect"
                        onClick={() => dispatch(resetProfile())}
                      >
                        {t("Cancel")}
                      </Button>
                    </Link>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(NewProfile);
